import { Flex, Heading, useTheme } from "@aws-amplify/ui-react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ResetPasswordHeader = () => {
  const { tokens } = useTheme();
  const { t } = useTranslation();

  return (
    <Flex direction="column">
      <Heading
        level={3}
        padding={`${tokens.space.xl} ${tokens.space.xl} 0`}
        paddingLeft={0}
        fontWeight={700}
        fontSize={"32px"}
      >
        {t("Reset Your Password")}
      </Heading>
      <Typography>
        {t(
          "Enter your email below and click Send Code to receive a one-time code to your email for your password reset."
        )}
      </Typography>
    </Flex>
  );
};
